import { FC, lazy } from 'react';
import { Route } from 'react-router-dom';
import { Redirect } from 'react-router';

import loadableRoutes, { contextPathViLink } from './loadableRoutes';
import { ConnectedSwitch } from './reactRouterConnected';
import { checkHasContextPath } from '../utils';
import { REDIRECT_LINK } from '../commons/constants';

const NotFoundPage = lazy(() => import('../pages/DefaultPages/NotFoundPage'));

const Routes: FC = () => {
  let paths = [];
  let routes = {};

  const hasContextPath = checkHasContextPath();
  if (hasContextPath) {
    paths = [...Object.keys(contextPathViLink), ...Object.keys(loadableRoutes)];
    routes = { ...contextPathViLink, ...loadableRoutes };
  } else {
    paths = Object.keys(loadableRoutes);
    routes = loadableRoutes;
  }

  return (
    <ConnectedSwitch>
      {REDIRECT_LINK.map(({ from, to }) => (
        <Redirect key={from} from={from} to={to} />
      ))}
      {paths.map((path) => {
        const { component: WrappedComponent, ...routeProps } = routes[path];
        const WrapperComponent: FC = (props: any) => (
          <WrappedComponent {...routeProps} {...props} />
        );

        return <Route key={path} path={path} component={WrapperComponent} />;
      })}
      <Route render={() => <NotFoundPage />} />
    </ConnectedSwitch>
  );
};

export { loadableRoutes };
export default Routes;
